import type { ReactNode } from "react";

interface CardProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  /** Heading level for the title (default 2). */
  level?: 2 | 3;
  id?: string;
}

export function Card({ title, subtitle, actions, children, className, level = 2, id }: CardProps) {
  const H = level === 2 ? "h2" : "h3";
  return (
    <section className={["card", className ?? ""].filter(Boolean).join(" ")} aria-labelledby={title && id ? `${id}-title` : undefined} id={id}>
      {title || actions ? (
        <div className="card-header">
          <div>
            {title ? (
              <H className="card-title" id={id ? `${id}-title` : undefined}>
                {title}
              </H>
            ) : null}
            {subtitle ? <p className="card-subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="row">{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
